import {Expose, Type} from "class-transformer";
import Model from "./Model";
import User from "./User";
import Style from "./Style";

export default class Comment extends Model {
    text: string;

    @Type(() => User)
    user: User;

    @Type(() => Style)
    style: Style;

    @Type(() => Date)
    @Expose({name: "created_at"})
    createdAt: Date;
}


// WEBPACK FOOTER //
// ./app/client/_data/models/Comment.ts